module.exports = __webpack_public_path__ + "img/rafting-3.3d0c6acc.jpeg";